/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { agentsListPolicyGrants } from "../funcs/agentsListPolicyGrants.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { AgentPolicyGrant } from "../models/components/agentpolicygrant.js";
import {
  ListAgentPolicyGrantsRequest,
  ListAgentPolicyGrantsSecurity,
} from "../models/operations/listagentpolicygrants.js";
import { unwrapAsync } from "../types/fp.js";
export type AgentsListPolicyGrantsQueryData = Array<AgentPolicyGrant>;

export function prefetchAgentsListPolicyGrants(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListAgentPolicyGrantsRequest,
  security?: ListAgentPolicyGrantsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAgentsListPolicyGrantsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAgentsListPolicyGrantsQuery(
  client$: GramCore,
  request: ListAgentPolicyGrantsRequest,
  security?: ListAgentPolicyGrantsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<AgentsListPolicyGrantsQueryData>;
} {
  return {
    queryKey: queryKeyAgentsListPolicyGrants({
      agentId: request.agentId,
      gramSession: request.gramSession,
    }),
    queryFn: async function agentsListPolicyGrantsQueryFn(
      ctx,
    ): Promise<AgentsListPolicyGrantsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(agentsListPolicyGrants(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAgentsListPolicyGrants(
  parameters: { agentId: string; gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "agents", "listPolicyGrants", parameters];
}
